import React from 'react';
import { formatDate } from '../../../utils/timeUtils';

const CrewSeatingSetup = ({
  crew,
  setup,
  selectedSessions,
  onSetupNameChange,
  onDeleteSetup,
  onSessionAssignment,
  onRowerAssignment,
  getSeatPositions,
}) => (
  <div className="rounded-lg border bg-gray-50 p-4 shadow-sm sm:p-6">
    <div className="mb-4 flex flex-wrap items-center justify-between gap-2">
      <input
        type="text"
        value={setup.name}
        onChange={(e) => onSetupNameChange(crew.id, setup.id, e.target.value)}
        className="rounded border-none bg-transparent px-2 py-1 text-xl font-semibold focus:outline-none focus:ring-2 focus:ring-blue-500"
        placeholder="Enter setup name"
      />
      <button
        onClick={() => onDeleteSetup(crew.id, setup.id)}
        className="p-2 text-red-600 transition-colors hover:text-red-800"
        title="Delete setup"
      >
        <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
          />
        </svg>
      </button>
    </div>
    <div className="mb-6">
      <h4 className="mb-2 text-sm font-medium text-gray-700">Sessions</h4>
      <div className="flex flex-wrap gap-2">
        {selectedSessions.map((session) => {
          const isAssigned = setup.sessions.includes(session.id);
          return (
            <button
              key={session.id}
              onClick={() => onSessionAssignment(crew.id, setup.id, session.id, !isAssigned)}
              className={`rounded-full px-3 py-1 text-sm font-medium transition-colors ${
                isAssigned
                  ? 'bg-blue-600 text-white shadow-sm'
                  : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
              }`}
            >
              {session.title} ({formatDate(new Date(session.date)).replace(/\//g, '-')})
            </button>
          );
        })}
      </div>
    </div>
    <div className="mb-4">
      <h4 className="mb-2 text-sm font-medium text-gray-700">Position Assignments</h4>
      <div className="space-y-3">
        {getSeatPositions(crew.boat_type).map((seatNumber) => {
          const assignedUserId = setup.seating[seatNumber];
          return (
            <div key={seatNumber} className="flex flex-wrap items-center gap-3 sm:gap-4">
              <div className="w-16 text-sm font-medium text-gray-700 sm:w-20">
                {seatNumber === 0 ? 'Cox' : `Seat ${seatNumber}`}
              </div>
              <div className="relative flex-1">
                <select
                  value={assignedUserId || ''}
                  onChange={(e) =>
                    onRowerAssignment(
                      crew.id,
                      setup.id,
                      seatNumber,
                      e.target.value ? parseInt(e.target.value) : null
                    )
                  }
                  className={`w-full min-w-[200px] rounded-md border px-3 py-2 text-sm transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                    assignedUserId
                      ? 'border-blue-300 bg-blue-100'
                      : 'border-gray-300 bg-gray-50 hover:border-gray-400'
                  }`}
                >
                  <option value="">Select rower</option>
                  {crew.members?.map((member) => (
                    <option key={member.user_id} value={member.user_id}>
                      {member.user?.first_name} {member.user?.last_name}
                    </option>
                  ))}
                </select>
                {assignedUserId && (
                  <div className="absolute right-2 top-1/2 -translate-y-1/2 transform">
                    <svg className="h-4 w-4 text-blue-600" fill="currentColor" viewBox="0 0 20 20">
                      <path
                        fillRule="evenodd"
                        d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
    <div className="flex items-center justify-between rounded border bg-white p-3 text-sm text-gray-600">
      <span>
        {Object.keys(setup.seating).length} positions locked,{' '}
        {getSeatPositions(crew.boat_type).length - Object.keys(setup.seating).length} variable
      </span>
      {Object.keys(setup.availability).length > 0 && (
        <div className="flex items-center space-x-2">
          {Object.values(setup.availability).every((result) => result.is_available) ? (
            <span className="flex items-center text-green-600">
              <div className="mr-1 h-2 w-2 rounded-full bg-green-500"></div>
              Available
            </span>
          ) : (
            <span className="flex items-center text-red-600">
              <div className="mr-1 h-2 w-2 rounded-full bg-red-500"></div>
              Conflicts
            </span>
          )}
        </div>
      )}
    </div>
  </div>
);

export default CrewSeatingSetup;
